module.exports = __webpack_public_path__ + "img/download.4ed3fc71.svg";